<h1>{{ "SYNC.SYNCHRONIZATION" | appString }}</h1>

<div>
  <button (click)="clickSync()">
    {{ "SYNC.SYNCHRONIZE" | appString }}
  </button>
</div>
<br>

<h1>{{ "SYNC.DEBUG" | appString }}</h1>

<div>
  <button (click)="clickDeleteSync()">
    {{ "SYNC.DELETE_SYNC" | appString }}
  </button>
</div>
<br>
<div>
  <button (click)="clickDeleteStore()">
    {{ "SYNC.DELETE_STORE" | appString }}
  </button>
</div>
